import PageTitle from "../../components/PageTitle";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";
import PageContent from "../../components/PageContent";
import useAuth from "../../hooks/AuthHook";
import useApi from "../../hooks/ApiHook";
import { useEffect, useState } from "react";
import If from "../../components/If";
import Loading from "../../components/Loading";
import usePaginator from "../../hooks/PaginatorHook";
import { Dropdown } from 'primereact/dropdown';
import { useNavigate, useSearchParams } from "react-router-dom";

const statusList = [
    { label: 'Ativos', value: 'ACTIVE' },
    { label: 'Inativos', value: 'INACTIVE' },
];

export default function() {

    const api = useApi();
    const navigate = useNavigate();
    const [ units, setUnits ] = useState([]);
    const [ loading, setLoading ] = useState(true);
    const { page, limit, setTotal, Paginator } = usePaginator();
    const [ searchParams, setSearchParams ] = useSearchParams();
    const [ status, setStatus ] = useState(searchParams.get('status') || 'ACTIVE');
    
    useEffect(() => {
        setLoading(true);
        api.get(`measurement-units?page=${page}&limit=${limit}&active=${status === 'ACTIVE'}`).then(({ data }) => {
            setUnits(data.data);
            setTotal(data.total);
            setSearchParams({ page, limit, status });
        }).finally(() => setLoading(false));
    }, [page, limit, status]);

    const actions = unit => (
        <>
            <Button icon="pi pi-pencil" title="Editar" onClick={() => navigate('./' + unit.symbol)}/>
        </>
    );

    const titleButtons = (
        <Button label="Adicionar" onClick={() => navigate('./new')}/>
    );

    const Filters = () => (
        <div className="mb-3 flex">
            <Dropdown 
                value={status} 
                options={statusList} 
                onChange={e => setStatus(e.value)}
                placeholder="Select a City" 
                className="w-full md:w-14rem"/>
        </div>
    );

    return (
        <div>
            <PageTitle title="Unidades de medida" subtitle="Defina e controle as unidades de medida dos produtos" end={titleButtons}/>
            <PageContent>
                <If condition={loading}>
                    <Loading/>
                </If>
                <If condition={!loading}>
                    <Filters/>
                    <DataTable value={units} selectionMode="single" emptyMessage="Nada encontrado" rowClassName={u => ({ 'opacity-40': !u.active })}>
                        <Column field="symbol" header="Símbolo" style={{width:'10%'}}></Column>
                        <Column field="description" header="Descrição"></Column>
                        <Column body={actions} header="Ações" align='right'></Column>
                    </DataTable>
                    <Paginator/>
                </If>
            </PageContent>
        </div>
    );
}